<script context="module" lang="ts">
	export let modals = [];
</script>

<script lang="ts">
	import { createEventDispatcher, onMount, tick } from 'svelte';
	import Portal from 'svelte-portal';

	export let fullscreen = false;
	let modal;
	const dispatch = createEventDispatcher();

	const close = () => {
		dispatch('close');
	};

	const handleKeydown = (event: KeyboardEvent) => {
		if (event.key === 'Escape' && modals[modals.length - 1] === modal) {
			close();
		}
	};
	let previouslyFocusedElement;
	let closeButton;

	onMount(() => {
		previouslyFocusedElement = document.activeElement;
		document.documentElement.classList.add('overflow-hidden');

		setTimeout(() => {
			closeButton?.focus();
		}, 100);

		modals.push(modal);

		return () => {
			document.documentElement.classList.remove('overflow-hidden');
			previouslyFocusedElement.focus();
			modals = modals.slice(0, modals.length - 1);
		};
	});
</script>

<svelte:window on:keydown={handleKeydown} />

<Portal target="#modals">
	<div
		class="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-md backdrop-filter p-16 flex items-center justify-center z-50"
		bind:this={modal}
	>
		<div
			class="bg-white p-6 flex flex-col relative w-full overflow-auto modal-inner"
			class:fullscreen
		>
			<button
				type="button"
				class="p-4 -m-4 absolute top-4 right-4"
				on:click={close}
				bind:this={closeButton}
			>
				<span class="sr-only">Schließen</span><svg
					width="18"
					height="18"
					aria-hidden="true"
					focusable="false"><use xlink:href="#icon-close" /></svg
				>
			</button>

			<div>
				<slot />
			</div>

			<div class="mt-auto space-x-5 flex justify-center">
				<slot name="bottom">
					<button class="button" type="button" on:click={close}>Schließen</button>
				</slot>
			</div>
		</div>
	</div>
</Portal>

<style lang="postcss">
	.modal-inner {
		min-height: 350px;
		max-width: 48rem;
		max-height: calc(100vh - 2rem);

		&.fullscreen {
			max-height: none;
			max-width: none;
			width: 100%;
			height: 100%;
		}
	}
</style>
